export default "__VITE_ASSET__7hoi6R3O__"